// assets
import { IconDashboard } from "@tabler/icons";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ArticleIcon from "@mui/icons-material/Article";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: "dashboard",
  type: "group",
  children: [
    {
      id: "default",
      title: "Dashboard",
      type: "item",
      url: "/dashboard",
      icon: DashboardRoundedIcon,
      color: "#5e35b1", // Deep Purple
      breadcrumbs: false,
    },
    {
      id: "admissions",
      title: "Admissions & Batches",
      type: "collapse",
      icon: HowToRegIcon,
      color: "#00bcd4", // Cyan
      children: [
        {
          id: "Batch",
          title: "Batches",
          type: "collapse",
          breadcrumbs: false,
          children: [
            {
              id: "All Batches",
              title: "All Batches",
              type: "item",
              url: "/dashboard/batch/allBatches",
              breadcrumbs: false,
            },
            {
              id: "Generate ICard",
              title: "Generate ICard",
              type: "item",
              url: "/dashboard/batch/generateICard",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "entranceExam",
          title: "Entrance Exam",
          type: "collapse",
          breadcrumbs: false,
          children: [
            {
              id: "createExam",
              title: "Create Exam",
              type: "item",
              url: "/dashboard/entranceExam/createExam",
              breadcrumbs: false,
            },
            {
              id: "AllEntranceExams",
              title: "All Entrance Exams",
              type: "item",
              url: "/dashboard/entranceExam/allExams",
              breadcrumbs: false,
            },
            {
              id: "Upload Result",
              title: "Upload Result",
              type: "item",
              url: "/dashboard/entranceExam/uploadResult",
              breadcrumbs: false,
            },
          ],
        },
      ],
    },
    {
      id: "academics",
      title: "Academics",
      type: "collapse",
      icon: MenuBookIcon,
      color: "#ff9800", // Orange
      children: [
        {
          id: "Lecture Arrangement",
          title: "Lecture Arrangement",
          type: "collapse",
          breadcrumbs: true,
          children: [
            {
              id: "Schedule Lecture",
              title: "Schedule Lecture",
              type: "item",
              url: "/dashboard/LectureArrangement/scheduleLecture",
              breadcrumbs: true,
            },
            {
              id: "Show All Lectures",
              title: "All Scheduled Lectures",
              type: "item",
              url: "/dashboard/LectureArrangement/allLectures",
              breadcrumbs: true,
            },
          ],
        },
        {
          id: "mainExam",
          title: "Mains Exam",
          type: "collapse",
          breadcrumbs: false,
          children: [
            {
              id: "createmainExam",
              title: "Create Descriptive Exam",
              type: "item",
              url: "/dashboard/mainExam/createExam",
              breadcrumbs: false,
            },
            {
              id: "All Mains Exams",
              title: "All Descriptive Exams",
              type: "item",
              url: "/dashboard/mainExam/allExams",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "regularExam",
          title: "Regular Exam",
          type: "collapse",
          breadcrumbs: false,
          children: [
            {
              id: "createExam",
              title: "Create MCQ Exam",
              type: "item",
              url: "/dashboard/regularExam/createExam",
              breadcrumbs: false,
            },
            {
              id: "All Regular Exams",
              title: "All MCQ Exams",
              type: "item",
              url: "/dashboard/regularExam/allExams",
              breadcrumbs: false,
            },
            {
              id: "Upload Result",
              title: "Upload Result",
              type: "item",
              url: "/dashboard/regularExam/generateResult",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "questionBank",
          title: "Question Bank",
          type: "collapse",
          breadcrumbs: false,
          children: [
            {
              id: "descriptiveQuestions",
              title: "Descriptive",
              type: "item",
              url: "/dashboard/mainsquestionBank/createQuestion",
              breadcrumbs: false,
            },
            {
              id: "mcqQuestions",
              title: "MCQ",
              type: "item",
              url: "/dashboard/questionBank/createQuestion",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "readingReport",
          title: "Student Reading Updates",
          type: "collapse",
          breadcrumbs: true,
          children: [
            {
              id: "upadateReadingStatus",
              title: "Update Reading Report",
              type: "item",
              url: "/dashboard/readingReport/upadateReadingStatus",
              breadcrumbs: true,
            },
          ],
        },
      ],
    },
    {
      id: "studentManagement",
      title: "Student Management",
      type: "collapse",
      icon: PeopleAltIcon,
      color: "#4caf50", // Green
      children: [
        {
          id: "studentFile",
          title: "Student File",
          type: "collapse",
          breadcrumbs: true,
          children: [
            {
              id: "searchStudentFile",
              title: "Search Student File",
              type: "item",
              url: "/dashboard/studentFile/searchStudentFile",
              breadcrumbs: true,
            },
          ],
        },
        {
          id: "Attendance",
          title: "Attendance",
          type: "item",
          url: "/dashboard/Attendance",
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "libraryManagement",
      title: "Library Management",
      type: "collapse",
      icon: LocalLibraryIcon,
      color: "#f44336", // Red
      children: [
        {
          id: "AddBook",
          title: "Add Book",
          type: "item",
          url: "/dashboard/libraryManagement/addBook",
          breadcrumbs: true,
        },
        {
          id: "AllBooks",
          title: "All Books",
          type: "item",
          url: "/dashboard/libraryManagement/allBooks",
          breadcrumbs: true,
        },
        {
          id: "issueBook",
          title: "Issue Book",
          type: "item",
          url: "/dashboard/libraryManagement/issueBook",
          breadcrumbs: true,
        },
        {
          id: "renewBook",
          title: "Renew Book",
          type: "item",
          url: "/dashboard/libraryManagement/renewBook",
          breadcrumbs: true,
        },
        {
          id: "receiveBook",
          title: "Receive Book",
          type: "item",
          url: "/dashboard/libraryManagement/receiveBook",
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "officeManagement",
      title: "Office Management",
      type: "collapse",
      icon: BusinessCenterIcon,
      color: "#e91e63", // Pink
      children: [
        {
          id: "Staff Leave Management",
          title: "Staff Leave Management",
          type: "collapse",
          breadcrumbs: true,
          children: [
            {
              id: "Raise Leave",
              title: "Raise Leave",
              type: "item",
              url: "/dashboard/staffLeaveManagement/raiseLeave",
              breadcrumbs: true,
            },
            {
              id: "My Leaves",
              title: "My Leaves",
              type: "item",
              url: "/dashboard/staffLeaveManagement/myLeaves",
              breadcrumbs: true,
            },
          ],
        },
      ],
    },
    {
      id: "dataEntryTools",
      title: "Data Entry Tools",
      type: "collapse",
      icon: AppRegistrationIcon,
      color: "#3f51b5", // Indigo
      breadcrumbs: true,
      children: [
        {
          id: "createRoom",
          title: "Create Room",
          type: "item",
          url: "/dashboard/admintools/createRooms",
          breadcrumbs: true,
        },
        {
          id: "createSubjects",
          title: "Create Subjects",
          type: "item",
          url: "/dashboard/admintools/createSubjects",
          breadcrumbs: true,
        },
        {
          id: "createTopics",
          title: "Create Topics",
          type: "item",
          url: "/dashboard/admintools/createTopics",
          breadcrumbs: true,
        },
        {
          id: "createTargetedExam",
          title: "Create Targeted Exam",
          type: "item",
          url: "/dashboard/admintools/createTargetedExam",
          breadcrumbs: true,
        },
        {
          id: "uploadDocuments",
          title: "Upload Documents",
          type: "item",
          url: "/dashboard/admintools/uploadDocuments",
          breadcrumbs: true,
        },
      ],
    },
  ],
};

export default dashboard;
